import React from 'react';
import './LoadingOverlay.css'; // Importa o arquivo de estilos CSS

const LoadingOverlay = () => {
    return (
        <div className={`overlay show`}>
            <div className="loader"></div>
        </div>
    );
};

export default LoadingOverlay;
